export default function redirectToSellerVersion() {
  // Get seller cookie
  const sellerCookie = document.cookie.split('; ').find(row => row.startsWith('seller='));
  const sellerCookieValue = sellerCookie ? sellerCookie.split('=')[1] : null;

  // Don't redirect if already on seller version
  const urlParams = new URLSearchParams(window.location.search);
  const isSellerParam = urlParams.get('myyja') === '1';

  // Redirect to seller version if not already there
  if (!isSellerParam && sellerCookieValue === '1') {
    const url = new URL(window.location.href);
    url.searchParams.set('myyja', '1');
    window.location.href = url.toString();
  }
}
